import { actionTypeAdmin } from "../types";

const initialState = {
    loading: false,
    error: null,
    getDoctersByPhoneNumOrEmailData: [],
    getPatientViewDetailsData: []
};

const reducerAdmin = (state = initialState, action) => {

    switch (action.type) {
        case actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_SUCCESS:
            return {
                ...state,
                getDoctersByPhoneNumOrEmailData: action.payload,
                error: null,
            };
        case actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_SUCCESS:
            return {
                ...state,
                getPatientViewDetailsData: action.payload,
                error: null,
            };
        case actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_FAILURE:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }


}
export default reducerAdmin;